import { makeBackendGetCallWithJsonResponse } from "../../store/utils/fetch";
import { AUTOCOMPLETE } from "../../store/utils/routes";
import { AutocompleteSuggestion } from "../../store/models/autocomplete";

export const fetchAutocomplete = async (query: string) => {
  const params = `?search=${query}`;
  const response = await makeBackendGetCallWithJsonResponse<
    AutocompleteSuggestion[]
  >(AUTOCOMPLETE, params);

  if (response.success) {
    return response.resultJson;
  }
  throw new Error(String(JSON.stringify(response.resultJson)));
};

export default fetchAutocomplete;
